import { FC, useMemo } from 'react';

import { getTextBehaviourClassName } from './internal/utils/getTextBehaviourClassName';
import { InteractiveTextProps, InteractiveTypographyFactoryProps, LinkProps } from './types';

const InteractiveTextFactory: FC<InteractiveTypographyFactoryProps> = props => {
  const { behaviour = null, children, fullWidth = false, title, display = 'inline-flex', track } = props;

  const textBehaviourClassName = useMemo(
    () =>
      getTextBehaviourClassName({
        behaviour,
        display,
        fullWidth,
        isLink: props.as === 'link',
      }),
    [behaviour, display, fullWidth, props.as],
  );

  switch (props.as) {
    case 'link':
      return (
        <a
          className={textBehaviourClassName}
          href={props.href}
          target={props.target}
          title={title}
          onClick={(event): void => {
            track();

            props.onClick?.(event);
          }}
        >
          {children}
        </a>
      );

    default:
      return (
        <span
          className={textBehaviourClassName}
          title={title}
          onClick={(event): void => {
            track();

            props.onClick?.(event);
          }}
        >
          {children}
        </span>
      );
  }
};

export const InteractiveText: FC<InteractiveTextProps> = props => <InteractiveTextFactory {...props} as="text" />;

export const Link: FC<LinkProps> = props => {
  const { behaviour = 'hover_primary_to_primary_hover', target = '_blank', children, ...restProps } = props;

  return (
    <InteractiveTextFactory {...restProps} as="link" behaviour={behaviour} target={target}>
      {children}
    </InteractiveTextFactory>
  );
};
